import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { getEnv } from "shared/utils";
import { withTheme } from "shared/context/theme";
import { Search as SearchIcon } from "backpack-ui/dist/components/icon";
import Modal from "./Modal";
import themes from "./themes";
import styles from "./styles.css";

class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isActive: false };
  }

  componentDidMount = () => {
    // Dispatch this event from anywhere to open search modal
    document.addEventListener("GlobalHeader/openSearch", this.setActive);
  };

  setActive = (event) => {
    event.preventDefault(); // if called from click event
    this.setState({ isActive: true });
  };

  setInactive = () => {
    this.setState({ isActive: false });
  };

  render() {
    const { theme, className } = this.props;
    const { isActive } = this.state;

    return (
      <React.Fragment>
        <a
          href={getEnv("SEARCH_URL")}
          className={cn({
            [theme.styles.container]: true,
            [theme.styles.isActive]: isActive,
            [className]: className,
          })}
          onClick={this.setActive}
        >
          <SearchIcon className={theme.styles.icon} />
          <span className={theme.styles.title}>Search Lonely Planet</span>
        </a>
        <Modal isOpen={isActive} onRequestClose={this.setInactive} />
      </React.Fragment>
    );
  }
}

Search.propTypes = {
  theme: PropTypes.shape({
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

Search.defaultProps = {
  className: "",
};

export default withTheme(Search, styles, themes);
